import React, { useState } from 'react'
import './ProductDescriptionTabsComponent.css'
import { Accordion, Nav, Tab } from 'react-bootstrap'
import OverviewTabContent from './OverviewTabContent/OverviewTabContent';
import PaperTypeTabContent from './PaperTypeTabContent/PaperTypeTabContent';
import DesignGuidlineComponent from './DesignGuidlineComponent/DesignGuidlineComponent';

const ProductDescriptionTabsComponent = ({product}) => {

    const [activeTab, setActiveTab] = useState("Overview");

    return (
        <section className='ProductDescriptionTabsComponent'>

            <div className='main_content_holder'>
                <Tab.Container
                    id="left-tabs-example"
                    className="faq_tabs_container"
                    activeKey={activeTab}
                    onSelect={(key) => setActiveTab(key)}
                >
                    <div>
                        <div className="col-md-6 col-sm-12 col-12">
                            <Nav variant="pills" className="all_tabs_holder" fill>
                                <Nav.Item className='tab_holder'>
                                    <Nav.Link eventKey="Overview" className="tab_btn">
                                        Overview
                                    </Nav.Link>
                                </Nav.Item>

                                <Nav.Item className='tab_holder'>
                                    <Nav.Link eventKey="Paper_Types" className="tab_btn">
                                        Paper Types
                                    </Nav.Link>
                                </Nav.Item>

                                <Nav.Item className='tab_holder'>
                                    <Nav.Link eventKey="Design_Guidelines" className="tab_btn">
                                        Design Guidelines
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </div>
                        <div>
                            <Tab.Content>
                                <Tab.Pane eventKey="Overview">
                                    <OverviewTabContent product={product}/>
                                </Tab.Pane>

                                <Tab.Pane eventKey="Paper_Types">
                                    <PaperTypeTabContent product={product}/>
                                </Tab.Pane>

                                <Tab.Pane eventKey="Design_Guidelines">
                                    <DesignGuidlineComponent product={product}/>
                                </Tab.Pane>
                            </Tab.Content>
                        </div>
                    </div>
                </Tab.Container>
            </div>


        </section>
    )
}

export default ProductDescriptionTabsComponent
